import { Navigate, useParams, useSearchParams } from "react-router-dom";
import GetPaid from "@/features/get-paid/GetPaidRuntime";
import { legacyModeratorPath, testGradingRedirect } from "@/components/moderator/moderator-navigation";

/** "/moderator" and its old "?tab=" links: each tab is its own page now. */
export function ModeratorIndexRedirect() {
  const { lang = "fr" } = useParams<{ lang: string }>();
  const [params] = useSearchParams();
  return <Navigate to={legacyModeratorPath(lang, params.get("tab"))} replace />;
}

/** The grading page (the URL the notification e-mails carry) only grades. */
export function ModeratorTestGradingRoute() {
  const { lang = "fr" } = useParams<{ lang: string }>();
  const [params] = useSearchParams();
  const redirect = testGradingRedirect(lang, params.get("section"));
  return redirect ? <Navigate to={redirect} replace /> : <GetPaid />;
}

/** The annotation page moved into the tools. */
export function ModeratorAnnotateRedirect() {
  const { lang = "fr" } = useParams<{ lang: string }>();
  return <Navigate to={`/${lang}/moderator/tools?tab=annotate`} replace />;
}
